import { KSIPreloadAPIConfig } from '@sailor/ksi-tools-preload-request';
import { SLGundamMainReqPrelodAPIConfig, SLGundamMainEuReqPrelodAPIConfig } from '@sailorgundam/gundam-preload-api-register';
import {
  KeemartCategoryListPreloadAPIConfig,
  KeemartSkuListPreloadAPIConfig,
  KeemartSupplyPreloadAPIConfig,
  KeemartOrderDetailPreloadAPIConfig,
  KeemartSearchGuidePreloadAPIConfig,
  KeemartSkuDetailPreloadAPIConfig,
  KeemartSearchResultPreloadAPIConfig
} from '@osgfe/keemart-preload-api-register';
import { SLChannelListPrelodAPIConfig } from '../Configs/ChannelList/index';
import { SLPreloadOrderStatusAPIConfig } from '../Configs/OrderStatus';
import { SLPreloadShopAPIConfig } from '../Configs/Shop/index';

const SLPreloadAPIRegistry: KSIPreloadAPIConfig[] = [
  new SLChannelListPrelodAPIConfig(),
  new SLPreloadOrderStatusAPIConfig(),
  new SLPreloadShopAPIConfig(),
  new SLGundamMainReqPrelodAPIConfig(),
  new SLGundamMainEuReqPrelodAPIConfig(),
  new KeemartCategoryListPreloadAPIConfig(),
  new KeemartSkuListPreloadAPIConfig(),
  new KeemartSupplyPreloadAPIConfig(),
  new KeemartOrderDetailPreloadAPIConfig(),
  new KeemartSearchGuidePreloadAPIConfig(),
  new KeemartSkuDetailPreloadAPIConfig(),
  new KeemartSearchResultPreloadAPIConfig()
];

export { SLPreloadAPIRegistry };
